/*
 * @Author: 王枫叶
 * @Date: 2020-12-17 20:38:54
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-26 14:38:36
 */
import ajax from '../utils/request'

const fictionApi = {
  /***************************小说列表****************************** */
  // 获取列表
  getfFiction(params) {
    return ajax({
      url: '/fiction/list',
      type: 'post',
      params: params
    })
  },
  // 修改
  updateFiction(params) {
    return ajax({
      url: '/fiction/edit',
      type: 'post',
      params: params
    })
  },
    // 新增
    addFiction(params) {
      return ajax({
        url: '/fiction/add',
        type: 'post',
        params: params
      })
    },
      // 删除
    deleteFiction(params) {
    return ajax({
      url: '/fiction/del',
      type: 'delete',
      params: params
    })
  },  
  // 查看报错小详情
  getErr(params) {
    return ajax({
      url: '/fiction/get',
      type: 'post',
      params: params
    })
  },  
  /***************************举报列表****************************** */
  // 获取列表
  getErrFeedback(params) {
    return ajax({
      url: '/errFeedback/list',
      type: 'post',
      params: params
    })
  },
  // 修改
  updateErrFeedback(params) {
    return ajax({
      url: '/errFeedback/edit',
      type: 'post',
      params: params
    })
  },
    // 新增
    addErrFeedback(params) {
      return ajax({
        url: '/errFeedback/add',
        type: 'post',
        params: params
      })
    },
      // 删除
    deleteErrFeedback(params) {
    return ajax({
      url: '/errFeedback/del',
      type: 'delete',
      params: params
    })
  },
  /***************************有声小说列表****************************** */
  // 获取列表 
  getAudiobook(params) {
    return ajax({
      url: '/audiobook/list',
      type: 'post',
      params: params
    })
  },
  // 本书配置
  updateAudiobook(params) {
    return ajax({
      url: '/audiobook/edit',
      type: 'post',
      params: params
    })
  },
    // 新增
    addAudiobook(params) {
      return ajax({
        url: '/audiobook/add',
        type: 'post',
        params: params
      })
    },
      // 删除
    deleteAudiobook(params) {
    return ajax({
      url: '/audiobook/del',
      type: 'delete',
      params: params
    })
  } ,
    // 一键配置
    editPrice(params) {
      return ajax({
        url: '/audiobook/editBatch',
        type: 'post',
        params: params
      })
    },
}
export default fictionApi
